module.exports = __webpack_public_path__ + "media/entities/1209-70c9c6e0.png";